import { DEFAULT_FIELD_ERROR } from './constants';
const isNotEmpty = (value) => Boolean(value?.trim());
export const validateAirport = async (value, options) => {
    const trimmedValue = value.trim();
    if (!isNotEmpty(trimmedValue)) {
        return { error: DEFAULT_FIELD_ERROR };
    }
    if (options?.isValueInList === false) {
        return { error: 'Выберите аэропорт из списка' };
    }
    return { error: null };
};
